var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "#1f2923",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99995 10.8C3.34898 10.8 1.19995 8.65092 1.19995 5.99995C1.19995 3.34898 3.34898 1.19995 5.99995 1.19995C8.65092 1.19995 10.8 3.34898 10.8 5.99995C10.8 8.65092 8.65092 10.8 5.99995 10.8ZM6.59995 4.19995C6.59995 4.53132 6.33132 4.79995 5.99995 4.79995C5.66858 4.79995 5.39995 4.53132 5.39995 4.19995C5.39995 3.86858 5.66858 3.59995 5.99995 3.59995C6.33132 3.59995 6.59995 3.86858 6.59995 4.19995ZM5.99995 5.39995C5.66858 5.39995 5.39995 5.66858 5.39995 5.99995V7.79995C5.39995 8.13132 5.66858 8.39995 5.99995 8.39995C6.33132 8.39995 6.59995 8.13132 6.59995 7.79995V5.99995C6.59995 5.66858 6.33132 5.39995 5.99995 5.39995Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.8a5995b04c0410c74093cb30bc688d04.svg";
export { ForwardRef as ReactComponent };